module.exports = __webpack_public_path__ + "media/images/page/location_ic-bc3aa80f349c51093bf301f74b67d2a5.svg";